import { useState } from 'react'
import Loading from '../Loading'
import Input from '../Input2'

const urlRegexes = {
  album: /https?:\/\/.+\/album\/.+/,
  song: /https?:\/\/.+\/track\/.+/,
  home: /(https:\/\/)?(([^.]+)\.)?bandcamp\.com\/?$/,
}

const errorHome =
  'Bandcamp home URLs (eg. https://you.bandcamp.com) are not supported. You must supply a specific track or release URL (eg. https://you.bandcamp.com/album/my-album)'

const TrackInput = ({ onAddItem, order }) => {
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState('')

  const handleBlur = () => {
    if (value.length > 0) setError('Invalid URL')
    setValue('')
  }

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) handleBlur()
  }

  const fetchBandcamp = async (url) => {
    try {
      const response = await fetch(`/api/bandcamp?url=${url}`)

      if (!response.ok) {
        setLoading(false)
        setError(response.statusText)
        return false
      }

      const data = await response.json()

      setLoading(false)
      setValue('')
      onAddItem({ order, ...data })

      return true
    } catch (error) {
      setLoading(false)
      setValue('')
      console.log(error)
      setError('Internal server error')

      return false
    }
  }

  const handleOnChange = async (e) => {
    setError(null)
    const url = e.target.value.split('?')[0]

    if (!!urlRegexes.album.exec(url) || !!urlRegexes.song.exec(url)) {
      setLoading(true)
      return fetchBandcamp(url)
    } else if (urlRegexes.home.exec(url)) {
      setError(errorHome)
      return false
    } else {
      setValue(url)
      return false
    }
  }

  if (loading) {
    return <Loading height={38} width={38} />
  } else {
    return (
      <Input
        autoFocus
        error={error}
        onBlur={handleBlur}
        onChange={handleOnChange}
        onKeyUp={handleKeyUp}
        placeholder="Paste a Bandcamp release or track URL"
        type="text"
        value={value}
      />
    )
  }
}

export default TrackInput
